export default __webpack_public_path__ + "static/media/pexels-pixabay-258154.34b172cc.jpg";